/**
 * View-mode identifiers and paging size for the dashboard shell.
 *
 * These were local `const X = "X"` declarations inside the Dashboard component.
 * They were lifted here when the shell and the IFAS hook both needed them. IFAS
 * and its view modes have since moved to ice-ifas-portal (#2089); what is left
 * is Claims.
 */
export const PAGE_COUNT = 10;

// Claims
export const CREATE_CLAIM = "CREATE_CLAIM";
export const HISTORY = "HISTORY";
export const PERSONAL_INFO = "PERSONAL_INFO";
